export default "__VITE_ASSET__DVx3bdfR__"